export default __webpack_public_path__ + "static/gameRabbit-955389858aeccb3b3f2cdeab8ff9df57.png";